const scrollShadow = () => {
  const $wrappers = document.querySelectorAll('.scroll-shadow');
  const updateDiv = (scrollPos, $wrapper, $el) => {
    const targetWidth = $el.scrollWidth - $el.clientWidth;
    if (scrollPos === 0) {
      $wrapper.classList.remove('not-left');
    }
    if (scrollPos > 0) {
      $wrapper.classList.add('not-left');
    }
    if (scrollPos < targetWidth) {
      $wrapper.classList.add('not-right');
    }
    if (scrollPos === targetWidth) {
      $wrapper.classList.remove('not-right');
    }
  };
  $wrappers.forEach($wrapper => {
    const $target = $wrapper.firstElementChild;
    let x = $target.scrollLeft;
    let isDown = false;
    let startX;
    let scrollLeft;
    updateDiv(x, $wrapper, $target);
    $target.addEventListener('scroll', () => {
      x = $target.scrollLeft;
      updateDiv(x, $wrapper, $target);
    });
    $target.addEventListener('mousedown', e => {
      isDown = true;
      $target.classList.add('active');
      startX = e.pageX - $target.offsetLeft;
      scrollLeft = $target.scrollLeft;
    });
    $target.addEventListener('mouseleave', () => {
      isDown = false;
      $target.classList.remove('active');
    });
    $target.addEventListener('mouseup', () => {
      isDown = false;
      $target.classList.remove('active');
    });
    $target.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      x = e.pageX - $target.offsetLeft;
      const walk = x - startX; // scroll-fast
      $target.scrollLeft = scrollLeft - walk;
    });
  });
};
export default scrollShadow;